import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import clientRoutes from "@/router/items/ClientRoutes";
import externalRoutes from "@/router/items/external/ExternalRoutes";
import cmmnRoutes from "@/router/items/common/cmmnRoutes";

const routes = [] as RouteRecordRaw[];

/**
 * 현재 호스트 타입에 따라 라우트 추가
 */
routes.push(...clientRoutes, ...externalRoutes, ...cmmnRoutes);

/**
 * 라우터 생성
 */
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 68 };
    }

    return { top: 0 };
  },
});

export default router;
